import React from 'react'
// import { Field, Form } from 'react-final-form'
// import { Formik } from 'formik'
import BaseSelect from 'react-select'
import FixRequiredSelect from 'components/forms/FixRequiredSelect'
import Inview from 'components/Inview'
import axios from 'axios'
import { ReactSVG } from 'react-svg'

class FormContact extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      postedEmail: null,
      error: null,
      cityOpen: false,
      submitted: false,
    }
    this.cityOpenToggle = this.cityOpenToggle.bind(this)
    this.setSubmitted = this.setSubmitted.bind(this)
    this.updateFormValue = this.updateFormValue.bind(this)
  }

  updateFormValue = (key, value) => {
    let formValues = { ...this.state.formValues }
    formValues[key] = value
    this.setState({ formValues })
  }

  setSubmitted() {
    this.setState({
      submitted: true,
    })
  }

  cityOpenToggle() {
    this.setState((prevState) => {
      return {
        cityOpen: !prevState.cityOpen,
      }
    })
  }

  render() {
    const locationOptions = [
      { value: '北京', label: '北京' },
      { value: '上海', label: '上海' },
      { value: '杭州', label: '杭州' },
      { value: '南京', label: '南京' },
      { value: '成都', label: '成都' },
      { value: '广州', label: '广州' },
      { value: '深圳', label: '深圳' },
      { value: '其他', label: '其他' },
    ]

    const handleSubmit = (e) => {
      e.preventDefault()
      this.setState({ loading: true })

      const postData = this.state.formValues
      let url = process.env.GATSBY_EMAIL_URL
      url += '/contact-form/email.php'
      const isEmailLive = process.env.GATSBY_EMAIL_IS_LIVE === 'true'
      axios({
        method: 'post',
        url,
        data: {
          postData,
          isEmailLive,
        },
      }).then((response) => {
        if (response.data === 'success') {
          this.setState({ loading: false, submitted: true })
        }
      })
    }
    const { buttonAddClass } = this.props
    return (
      <div>
        <form autoComplete='off' onSubmit={handleSubmit}>
          <div className={`form-1 ${this.state.submitted ? '' : 'is-active'}`}>
            <Inview>
              <div className='mb-14 fade-in-up'>
                <p>
                  现在就与我们联络，预约厨房导览行程，或是进一步了解如何加入星选闪电的行列。
                </p>
              </div>
            </Inview>
            <Inview>
              <div className='fields-wrap fade-in-up'>
                <FormElementText
                  name='name'
                  label='姓名'
                  updateFormValue={this.updateFormValue}
                  addClass='form_name'
                />
                <FormElementText
                  name='mobile'
                  label='手机'
                  updateFormValue={this.updateFormValue}
                  addClass='form_phone'
                />
                <FormElementSelect
                  name='city'
                  label='意向城市'
                  options={locationOptions}
                  updateFormValue={this.updateFormValue}
                  addClass='form_city'
                />
              </div>
              <div
                className={`submit-wrap ${
                  this.state.loading ? 'is-loading' : ''
                }`}
              >
                <button
                  type='submit'
                  disabled={this.state.loading}
                  className={`btn--contact fade-in-up mt-14 ${buttonAddClass}`}
                >
                  <span className='default'>立即联系</span>
                  <span className='mask'>
                    <span className='hover'>
                      立即联系
                      <span className='arrow arrow-bar is-right'></span>
                    </span>
                  </span>
                </button>
                <div className='loader'>
                  <ReactSVG src='/loader.svg' />
                </div>
              </div>
            </Inview>
          </div>
          <div className={`form-3 ${this.state.submitted ? 'is-active' : ''}`}>
            <h3 className='h3 small'>
              恭喜，您已预约成功。
              <br className='hidden xl:inline' />
              星选小哥在快马加鞭向您奔来！
            </h3>
            <p className='mt-10 small'>
              等待的同时，欢迎您关注 <strong>星选闪电</strong> 微信公众号 |
              视频号 | 抖音号，了解更多品牌信息。
            </p>
            <p className='md:mb-20 small'>
              如果等心急了，欢迎直接致电 400-850-2727，与我们顾问直接对话！
            </p>
          </div>
        </form>
      </div>
    )
  }
}

export default FormContact

class FormElementText extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isFocus: false,
      isDone: false,
      textLength: 0,
      formValues: {
        name: null,
        mobile: null,
        city: null,
      },
    }
    this.setFocus = this.setFocus.bind(this)
    this.updateStatus = this.updateStatus.bind(this)
  }
  setFocus = (bool) => {
    this.setState({ isFocus: bool })
    this.updateStatus()
    if (!bool) {
      // leaving
      const input = document.querySelector(`input[name=${this.props.name}]`)
      if (input.value.length > 0) {
        this.state.isDone = true
      } else {
        this.state.isDone = false
      }
    }
  }

  handleChange = () => {
    this.updateStatus()
  }

  updateStatus = () => {
    const input = document.querySelector(`input[name=${this.props.name}]`)
    const textLength = input.value.length * 14
    this.setState({ textLength })
    this.props.updateFormValue(this.props.name, input.value)
  }

  render() {
    const { name, label, addClass } = this.props
    return (
      <div
        className={`form--element form--element--text
          ${this.state.isFocus ? 'focus' : ''}
          ${this.state.isDone ? 'done' : ''}
      `}
      >
        <label className='form--element--label'>{label}</label>
        {/* <div className='form--element--text'></div> */}
        {/* <div className='form--element--placeholder'>{label}</div> */}
        <input
          name={name}
          id={name}
          className={`form--element--text ${addClass}`}
          autoComplete='off'
          type='text'
          placeholder={this.state.isFocus ? '' : label}
          required
          onFocus={() => this.setFocus(true)}
          onBlur={() => this.setFocus(false)}
          onChange={() => this.handleChange()}
          pattern={name === 'mobile' ? '[0-9]{11}' : null}
          title={name === 'mobile' ? '手机号11位，无横线或空格' : null}
        />
        <div
          className='form--element--border'
          style={{ width: `${this.state.textLength}px` }}
        />
      </div>
    )
  }
}

const Select = (props) => (
  <FixRequiredSelect
    {...props}
    SelectComponent={BaseSelect}
    options={props.options || options}
  />
)

class FormElementSelect extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isFocus: false,
      isDone: false,
    }
    this.setFocus = this.setFocus.bind(this)
    this.updateStatus = this.updateStatus.bind(this)
  }
  setFocus = (bool) => {
    this.setState({ isFocus: bool })
    this.updateStatus()
    if (!bool) {
      // leaving
      const input = document.querySelector(`input[name=${this.props.name}]`)
      if (input.value.length > 0) {
        this.state.isDone = true
      } else {
        this.state.isDone = false
      }
    }
  }

  handleChange = () => {
    this.updateStatus()
  }

  updateStatus = () => {
    const input = document.querySelector(`input[name=${this.props.name}]`)
    this.props.updateFormValue(this.props.name, input.value)
  }

  render() {
    const { name, label, options, addClass } = this.props

    return (
      <div
        className={`form--element 
        ${this.state.isFocus ? 'focus' : ''}
        ${this.state.isDone ? 'done' : ''}
      `}
      >
        <label className='form--element--label'>{label}</label>
        <Select
          name={name}
          placeholder={this.state.isFocus ? '' : label}
          className={`form--element--select ${addClass}`}
          classNamePrefix='react-select'
          options={options}
          required
          onFocus={() => this.setFocus(true)}
          onBlur={() => this.setFocus(false)}
          onChange={this.handleChange}
          isSearchable={false}
        />
      </div>
    )
  }
}
